import { Fragment } from "react";

export const BookingInformation = (props) => {
  const { branding, bookingDetails } = props;
  return (
    <Fragment>
      <h3
        className="mt-3"
        style={{
          color: branding.headingColor,
          fontFamily: branding.headingFont,
        }}
      >
        Booking Information
      </h3>
      <table className="table table-bordered">
        <tbody>
          <tr>
            <th>Check-in Date</th>
            <td>{bookingDetails.fromdate}</td>
          </tr>
          <tr>
            <th>Check-out Date</th>
            <td>{bookingDetails.todate}</td>
          </tr>
          <tr>
            <th>Total Amount</th>
            <td>{bookingDetails.totalamount.toLocaleString()} VND</td>
          </tr>
          <tr>
            <th>Total Days</th>
            <td>{bookingDetails.totaldays}</td>
          </tr>
          <tr>
            <th>Transaction ID</th>
            <td>{bookingDetails.transactionId}</td>
          </tr>
          <tr>
            <th>Payment Method</th>
            <td>{bookingDetails.paymentMethod}</td>
          </tr>
          <tr>
            <th>Created At</th>
            <td>{new Date(bookingDetails.createdAt).toLocaleString()}</td>
          </tr>
          <tr>
            <th>Updated At</th>
            <td>{new Date(bookingDetails.updatedAt).toLocaleString()}</td>
          </tr>
        </tbody>
      </table>
    </Fragment>
  );
};
